module.exports = __webpack_public_path__ + "static/ironfang-8da477137bd2bba9bf0f73281d072203.png";